/* eslint-disable react/prop-types */
/* eslint-disable arrow-parens */
import { forwardRef, useState, useCallback } from "react";

import "date-fns";
import DateFnsUtils from "@date-io/date-fns";

import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Slide, Grid } from "@material-ui/core";

import EventIcon from "@material-ui/icons/Event";
import PublishIcon from "@material-ui/icons/Publish";
import DoneIcon from "@material-ui/icons/Done";
import Close from "@material-ui/icons/Close";

const Transition = forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const CustomDatePickerDialog = ({ dialogProps, setDialogProps, handleClose, editEndDate, setEditEndDate }) => {
	const { openDialog, title, textFields, actions, _id } = dialogProps;
	const [initialEndDate, setInitialEndDate] = useState(editEndDate);
	const [isEndDateValid, setIsEndDateValid] = useState(true);
	// console.log("editEndDate d", editEndDate);

	const handleSubmitCallback = useCallback(
		(callback) => {
			if ((initialEndDate !== "" || initialEndDate !== null) && (editEndDate === "" || editEndDate === null)) {
				setIsEndDateValid(false);
			} else {
				callback(editEndDate);
			}
		},
		[editEndDate, initialEndDate]
	);

	const handleDateChange = useCallback(
		(_date, name) => {
			const date = new Date(_date);
			const parsedDate = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
			setEditEndDate(parsedDate);
			setIsEndDateValid(true);
		},
		[setEditEndDate]
	);

	return (
		<div>
			<Dialog
				style={{ zIndex: 800 }}
				open={openDialog}
				onClose={handleClose}
				TransitionComponent={Transition}
				keepMounted
				aria-labelledby="alert-dialog-slide-title"
				aria-describedby="alert-dialog-slide-description"
			>
				<DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>

				<DialogContent>
					{textFields.map((textField, index) => {
						const { placeHolder, name, label, value } = textField;
						return (
							<>
								<Grid container spacing={1} className=" pf-grid-container " key={index}>
									<Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
										<MuiPickersUtilsProvider utils={DateFnsUtils}>
											<KeyboardDatePicker
												className="from-date-input date-input"
												id="from-date-input"
												inputVariant="outlined"
												placeholder={placeHolder}
												name={name}
												label={label}
												format="MM/dd/yyyy"
												error={false}
												value={editEndDate}
												onChange={(date) => handleDateChange(date, name)}
												InputProps={{
													readOnly: true
												}}
												InputLabelProps={{
													shrink: true
												}}
												//style={{ width: "340px", borderRadius: 50 }}
												keyboardIcon={<EventIcon style={{ color: "#7cb342" }} />}
												KeyboardButtonProps={{
													"aria-label": "change date"
												}}
												// disabled={!isButtonSelected}
												// disableElevation={!isButtonSelected}
												style={{
													// cursor: !isButtonSelected ? "not-allowed" : "pointer",
													pointerEvents: "unset",
													width: "250px",
													borderRadius: 50
												}}
												helperText={
													isEndDateValid === false ? "Please enter a valid end date" : null
												}
											/>
										</MuiPickersUtilsProvider>
									</Grid>
								</Grid>
							</>
						);
					})}
				</DialogContent>
				<DialogActions className="custom-dialog-action-button-container">
					{actions.map((action, index) => {
						const { label, callback, name } = action;

						return (
							<Button
								className={
									name === "submit"
										? "custom-dialog-action-button-green"
										: "custom-dialog-action-button-grey"
								}
								variant="contained"
								key={index}
								onClick={name === "Submit" ? () => handleSubmitCallback(callback) : () => callback()}
							>
								<span className="custom-dialog-action-button-label-with-icon">{label}</span>
								<span>
									{name === "Submit" ? (
										<DoneIcon className="custom-dialog-action-button-icon" />
									) : (
										<Close className="custom-dialog-action-button-icon" />
									)}
								</span>
							</Button>
						);
					})}
				</DialogActions>
			</Dialog>
		</div>
	);
};

export default CustomDatePickerDialog;
